import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import PrimaryButton from '../../core/PrimaryButton';
import SearchSelect from '../../core/SearchSelect';
import { globalStyles } from '../../core/style/gstheme';
import { getGraphFromProject } from '../../core/utils/utils';

const styles = Object.assign({}, globalStyles);

class UseTemplateDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this.cancellable = null;
    }

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let graph = this.props.projects.map(project => getGraphFromProject(project));
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: "http://www.w3.org/ns/shacl#NodeShape"
            }
        ];
        if (value !== "") {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                value: value,
                isExactMatch: false
            });
        }
        else {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label"
            });
        }
        let fullSearch =
        {
            search,
            graph,
            pageSize: 100,
            basicSort: true,
            exclude: [...this.props.exclude],
            language: lang,
            predicates: ["http://www.w3.org/2000/01/rdf-schema#label"],
            sort: "http://www.w3.org/2000/01/rdf-schema#label"
        };
        return fullSearch;
    };

    useTemplate = (id) => {
        // Check for incoming addition
        if (!this.props.exclude.includes(id)) {
            this.props.onUseTemplate(id);
        }
    };

    exitUseTemplate = () => this.setState({ open: false });

    render() {

        const { classes, defaultLang, exclude } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest="add-ontology-template" onClick={() => this.handleClickOpen()} title="Add templates" />
                <Dialog
                    data-test="add-ontology-template-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitUseTemplate}
                    aria-labelledby="find-template-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-template-dialog-title">Add Templates</DialogTitle>
                    <DialogContent style={{ height: 440, overflow: 'visible' }}>
                        <SearchSelect
                            dataTest="find-template"
                            focus={true}
                            sortProp="label"
                            search={(value, lang) => this.computeSearch(value, lang)}
                            listDisplay={(result, lang) => {
                                if (result.label[lang]) {
                                    return <Typography data-test="result-label" variant="body2">
                                        <Tooltip title={result.id}>
                                            <span>
                                                {result.label[lang]}
                                            </span>
                                        </Tooltip>
                                    </Typography>;
                                }
                                else return "No label available";
                            }}
                            isClickableResult={(result) => !result.invalid}
                            exclude={exclude}
                            title="Filter templates"
                            lang={defaultLang}
                            chosen={this.useTemplate} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <PrimaryButton onClick={this.exitUseTemplate}>Close</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

UseTemplateDialog.defaultProps = {
    exclude: []
};

UseTemplateDialog.propTypes = {
    classes: PropTypes.object,
    projects: PropTypes.array.isRequired,
    exclude: PropTypes.array,
    onUseTemplate: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(UseTemplateDialog);